import { Button, Result, Spin } from 'antd';
import { AppContext } from '../contexts/AppContext';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchUserAttributes } from '@aws-amplify/auth';

const ErrorPage: React.FC = () => {
  const { authInfo, setAuthInfo } = useContext(AppContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  return (
    <>
      <Result
        status="error"
        icon={loading ? <Spin size="large" style={{ height: 72 }} /> : undefined}
        title="アクセス権限がありません"
        subTitle="権限が存在するかご確認ください。"
        extra={[
          <Button
            type="primary"
            key="retry"
            onClick={async () => {
              setLoading(true);
              const attributes = await fetchUserAttributes();
              const client_account = attributes['custom:client_account'];
              setLoading(false);
              if (client_account) {
                setAuthInfo({
                  ...authInfo,
                  user: { ...authInfo.user, attributes },
                });
                navigate('/tralit/forecast');
              }
            }}
          >
            Retry
          </Button>,
          <Button
            key="signOut"
            onClick={() => {
              authInfo.signOut();
            }}
          >
            Logout
          </Button>,
        ]}
      ></Result>
    </>
  );
};

export default ErrorPage;
